import { CameraOutlined } from "@ant-design/icons";
import { message, Spin } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Urls, {
  BASE_URL,
  postRequest,
} from "../../../../../services/common/urls";
import lang from "../../../../../services/lang";
import "./ImageUploader.css";
//
function ImageUploader(props) {
  const { langIndex } = useSelector((x) => x.app);
  const { user_picture, updateImage, isLogo } = props;
  const [imageUrl, setImageUrl] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setImageUrl(user_picture);
  }, [user_picture]);

  const onDropImage = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) {
      return;
    }

    const file = files[0];
    // Validate file type
    const validTypes = ["image/png", "image/gif", "image/jpeg", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      message.error(lang(langIndex, "msg_something_wrong") + " - Invalid file type. Please select PNG, GIF, or JPEG image.");
      return;
    }

    // Validate file size (e.g., max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      message.error(lang(langIndex, "msg_something_wrong") + " - File size too large. Maximum size is 5MB.");
      return;
    }

    setIsUploading(true);
    var formData = new FormData();
    formData.append("file", file);
    
    postRequest(Urls.UPLOAD_USER_IMAGE, formData, (response) => {
      setIsUploading(false);
      
      if (response === null) {
        message.error(lang(langIndex, "msg_something_wrong") + " - Network error or server unavailable.");
        return;
      }
      
      if (response.status === true) {
        setImageUrl(response.url);
        updateImage(response.url);
        message.success("Image uploaded successfully");
      } else {
        const errorMsg = response.message || lang(langIndex, "msg_something_wrong");
        message.error(errorMsg);
      }
    });
    
    // Reset input value to allow selecting the same file again
    e.target.value = "";
  };

  return (
    <Spin spinning={isUploading}>
      <form className="user-manage-avatar-container">
        <div className="user-image-container">
          <img
            src={imageUrl}
            className={
              isLogo === true
                ? "logo-image-style"
                : "user-manage-dialog-avatar-style"
            }
            alt={isLogo ? "Logo" : "User Avatar"}
          />
        </div>
        <div className="user-manage-avatar-add-button-container">
          <label htmlFor="upload_image">
            <CameraOutlined
              className="user-manage-avatar-add-button-style"
              size={50}
            />
            <input
              type="file"
              id="upload_image"
              name="upload_image"
              style={{ display: "none" }}
              accept="image/x-png,image/gif,image/jpeg,image/jpg"
              onChange={onDropImage}
              disabled={isUploading}
            />
          </label>
        </div>
      </form>
    </Spin>
  );
}

export default ImageUploader;
